import axios from 'axios'
import config from '@/config'

function getApiHost() {
  switch(process.env.NODE_ENV) {
    case 'development' : return config.baseURL;
    default : return `${location.protocol}//${location.host.replace(/^[^\\.]*\./, 'api.')}/v1`;
  }
}

const baseUrl = getApiHost();
const http = axios.create({ baseURL: baseUrl, timeout: 10000000, });

http.defaults.headers.get['Content-Type'] = 'application/json'
http.defaults.headers.post['Content-Type'] = 'application/json'

http.interceptors.response.use((response) => response.data, error => Promise.reject(error.response || { status: 500, data: error.message }));
if(location.hostname == 'localhost') { window['http'] = http; }

global.setting = { image : '', slogan : '', manual : '', favicon : '' }
let custom_default = { image : '', slogan : '', manual : '', favicon : ''  }
const setting = () => global.setting
const Setting_Call = async () => {
  // support custom logo and slogan
  if(global.setting.slogan) { return; }
  try {
    let rs = await http.post('setting/custom', { target : 'settings', cmd : 'custom', favicon : '' })
    if(rs.error) { return console.error(rs.reason); }
    global.setting = Object.assign({}, global.setting, rs.body)
    if(!global.setting.slogan) { global.setting.slogan = 'F1-UWSS' }
    global.setting.slogan = global.setting.slogan.toUpperCase()

    custom_default = Object.assign({}, custom_default, global.setting)
    document.title = custom_default.slogan ? custom_default.slogan : 'UWSS ' + location.hostname.indexOf('.') > -1 ? location.hostname.split('.')[0] : 'UWSS'
    console.log('load slogan', custom_default.slogan)

    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = custom_default.favicon;

    if(location.hostname == 'localhost') { console.log("[+] load cutom setting", global.setting.slogan) }
  } catch (e) { console.error(e) }
}
export default { setting, Setting_Call, custom_default }
